import { useEffect, useState } from "react";
import { getRole } from "../../api/users";
import Marketplace from "../../components/Marketplace/MarketplaceOffers/MarketPlaceAll";

export default function OfferPage() {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const roleData = await getRole();
        setIsAdmin(roleData.role === "admin" || roleData.role === "superadmin");

      } catch (error) {
        console.error("Error checking user type:", error);
      } finally {
        setLoading(false);
      }
    };
    checkAdmin();

  }, []);

  if (loading) {
    return <p className="text-center mt-10">Loading...</p>;
  }

  return (
    <>
      {
        isAdmin ? (
          <Marketplace mode="admin" />
        ) :
          <Marketplace mode="user" />
      }
    </>
  );
}
